import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AdminAuthGuardService implements CanActivate {
  constructor(public authService: AuthService, public router: Router) {}

  canActivate(): boolean {
    // return true; // BATMAN
    const user = this.authService.getUser();
    if (user.uid) {
      if (user.type === 'admin') {
        return true;
      } else {
        if (user.type === 'business') {
          this.router.navigate(['business']);
        }
        if (user.type === 'customer') {
          this.router.navigate(['customer']);
        }
        return false;
      }
    } else {
      this.router.navigate(['login']);
      return false;
    }
  }
}
